module.exports = __webpack_public_path__ + "assets/img/contacts.afed66f4.svg";